import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type SetSiteLaborRateMutationVariables = Types.Exact<{
  input: Types.SetSiteLaborRateInput;
}>;


export type SetSiteLaborRateMutation = { __typename?: 'Mutation', setSiteLaborRate: { __typename?: 'SiteLocationPayload', siteLocation?: { __typename?: 'SiteLocationStateData', id: string, tenantId: string, name: string, erpId: string, status: Types.LocationStatus, timeZone?: string | null, created: Types.TDateISO, updated: Types.TDateISO, address?: { __typename?: 'SiteAddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string, latitude?: number | null, longitude?: number | null } | null, laborRates: Array<{ __typename?: 'SiteLaborRateStateData', laborTypeId: string, ratePerHour: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null }>, laborTypes: Array<{ __typename?: 'LaborTypeStateData', id: string, name: string }>, locations: Array<{ __typename?: 'LocationStateData', locationId: string, name: string, parentLocationId: string, locationType: Types.SiteLocationType, erpId: string, status: Types.LocationStatus }>, overheadRate?: { __typename?: 'OverheadRateStateData', costPerSqFtPerWeek: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null } | null, siteContacts: Array<{ __typename?: 'SiteContactStateData', role: Types.SiteContactRole, name: string, email: string, phone: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CancelScheduledLaborRateMutationVariables = Types.Exact<{
  input: Types.CancelScheduledLaborRateInput;
}>;


export type CancelScheduledLaborRateMutation = { __typename?: 'Mutation', cancelScheduledLaborRate: { __typename?: 'SiteLocationPayload', siteLocation?: { __typename?: 'SiteLocationStateData', id: string, tenantId: string, name: string, erpId: string, status: Types.LocationStatus, timeZone?: string | null, created: Types.TDateISO, updated: Types.TDateISO, address?: { __typename?: 'SiteAddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string, latitude?: number | null, longitude?: number | null } | null, laborRates: Array<{ __typename?: 'SiteLaborRateStateData', laborTypeId: string, ratePerHour: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null }>, laborTypes: Array<{ __typename?: 'LaborTypeStateData', id: string, name: string }>, locations: Array<{ __typename?: 'LocationStateData', locationId: string, name: string, parentLocationId: string, locationType: Types.SiteLocationType, erpId: string, status: Types.LocationStatus }>, overheadRate?: { __typename?: 'OverheadRateStateData', costPerSqFtPerWeek: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null } | null, siteContacts: Array<{ __typename?: 'SiteContactStateData', role: Types.SiteContactRole, name: string, email: string, phone: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type EditScheduledLaborRateMutationVariables = Types.Exact<{
  input: Types.EditScheduledLaborRateInput;
}>;


export type EditScheduledLaborRateMutation = { __typename?: 'Mutation', editScheduledLaborRate: { __typename?: 'SiteLocationPayload', siteLocation?: { __typename?: 'SiteLocationStateData', id: string, tenantId: string, name: string, erpId: string, status: Types.LocationStatus, timeZone?: string | null, created: Types.TDateISO, updated: Types.TDateISO, address?: { __typename?: 'SiteAddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string, latitude?: number | null, longitude?: number | null } | null, laborRates: Array<{ __typename?: 'SiteLaborRateStateData', laborTypeId: string, ratePerHour: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null }>, laborTypes: Array<{ __typename?: 'LaborTypeStateData', id: string, name: string }>, locations: Array<{ __typename?: 'LocationStateData', locationId: string, name: string, parentLocationId: string, locationType: Types.SiteLocationType, erpId: string, status: Types.LocationStatus }>, overheadRate?: { __typename?: 'OverheadRateStateData', costPerSqFtPerWeek: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null } | null, siteContacts: Array<{ __typename?: 'SiteContactStateData', role: Types.SiteContactRole, name: string, email: string, phone: string }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const SetSiteLaborRateDocument = new TypedDocumentString(`
    mutation SetSiteLaborRate($input: SetSiteLaborRateInput!) {
  setSiteLaborRate(input: $input) {
    siteLocation {
      ...SiteLocationStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment SiteLocationStateFields on SiteLocationStateData {
  id
  tenantId
  name
  erpId
  status
  timeZone
  created
  updated
  address {
    id
    toName
    addressLine1
    addressLine2
    city
    stateProvince
    zipcode
    country
    latitude
    longitude
  }
  laborRates {
    laborTypeId
    ratePerHour
    effectiveFrom
    effectiveTo
  }
  laborTypes {
    id
    name
  }
  locations {
    locationId
    name
    parentLocationId
    locationType
    erpId
    status
  }
  overheadRate {
    costPerSqFtPerWeek
    effectiveFrom
    effectiveTo
  }
  siteContacts {
    role
    name
    email
    phone
  }
}`);
export const CancelScheduledLaborRateDocument = new TypedDocumentString(`
    mutation CancelScheduledLaborRate($input: CancelScheduledLaborRateInput!) {
  cancelScheduledLaborRate(input: $input) {
    siteLocation {
      ...SiteLocationStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment SiteLocationStateFields on SiteLocationStateData {
  id
  tenantId
  name
  erpId
  status
  timeZone
  created
  updated
  address {
    id
    toName
    addressLine1
    addressLine2
    city
    stateProvince
    zipcode
    country
    latitude
    longitude
  }
  laborRates {
    laborTypeId
    ratePerHour
    effectiveFrom
    effectiveTo
  }
  laborTypes {
    id
    name
  }
  locations {
    locationId
    name
    parentLocationId
    locationType
    erpId
    status
  }
  overheadRate {
    costPerSqFtPerWeek
    effectiveFrom
    effectiveTo
  }
  siteContacts {
    role
    name
    email
    phone
  }
}`);
export const EditScheduledLaborRateDocument = new TypedDocumentString(`
    mutation EditScheduledLaborRate($input: EditScheduledLaborRateInput!) {
  editScheduledLaborRate(input: $input) {
    siteLocation {
      ...SiteLocationStateFields
    }
    errors {
      code
      message
    }
  }
}
    fragment SiteLocationStateFields on SiteLocationStateData {
  id
  tenantId
  name
  erpId
  status
  timeZone
  created
  updated
  address {
    id
    toName
    addressLine1
    addressLine2
    city
    stateProvince
    zipcode
    country
    latitude
    longitude
  }
  laborRates {
    laborTypeId
    ratePerHour
    effectiveFrom
    effectiveTo
  }
  laborTypes {
    id
    name
  }
  locations {
    locationId
    name
    parentLocationId
    locationType
    erpId
    status
  }
  overheadRate {
    costPerSqFtPerWeek
    effectiveFrom
    effectiveTo
  }
  siteContacts {
    role
    name
    email
    phone
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    SetSiteLaborRate: build.mutation<SetSiteLaborRateMutation, SetSiteLaborRateMutationVariables>({
      query: (variables) => ({ document: SetSiteLaborRateDocument, variables })
    }),
    CancelScheduledLaborRate: build.mutation<CancelScheduledLaborRateMutation, CancelScheduledLaborRateMutationVariables>({
      query: (variables) => ({ document: CancelScheduledLaborRateDocument, variables })
    }),
    EditScheduledLaborRate: build.mutation<EditScheduledLaborRateMutation, EditScheduledLaborRateMutationVariables>({
      query: (variables) => ({ document: EditScheduledLaborRateDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useSetSiteLaborRateMutation, useCancelScheduledLaborRateMutation, useEditScheduledLaborRateMutation } = injectedRtkApi;
